// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1f84f929","732":"eefbbcc9","977":"e6df7ed4"}[chunkId] + ".chunk.js";
};